import React from "react";
import object from "./type.json";
import "./ListHotelsType.css";

const ListHotelsType = () => {
  return (
    <div className="hotel-container">
      <h2 className="text-type">Browse by property type</h2>
      <div className="hotel-list">
        {object.map((hotel, index) => (
          <div className="hotel-card" key={index}>
            <img src={hotel.image} alt={hotel.name} className="hotel-image" />
            <h3 className="text-hotel">{hotel.name}</h3>
            <p className="count-hotel">{hotel.count} hotels</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListHotelsType;
